var _defs, _linearGradient, _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAcronymGridOptimized = function SvgAcronymGridOptimized(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "acronym-grid",
    viewBox: "0 0 353 359",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4275",
    x1: 130.5,
    x2: 130.5,
    y1: 12,
    y2: 490.6,
    gradientTransform: "matrix(.87379 0 0 .87379 -62.529 -59.908)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4279",
    x1: 255.5,
    x2: 255.5,
    y1: 12,
    y2: 490.6,
    gradientTransform: "matrix(.87379 0 0 .87379 -46.752 -59.908)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4283",
    x1: 380.5,
    x2: 380.5,
    y1: 12,
    y2: 490.6,
    gradientTransform: "matrix(.87379 0 0 .87379 -30.976 -59.908)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4287",
    x1: 130.5,
    x2: 130.5,
    y1: 12,
    y2: 490.6,
    gradientTransform: "matrix(.87379 0 0 .87379 -62.529 -44.005)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4291",
    x1: 255.5,
    x2: 255.5,
    y1: 12,
    y2: 490.6,
    gradientTransform: "matrix(.87379 0 0 .87379 -46.752 -44.005)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4295",
    x1: 380.5,
    x2: 380.5,
    y1: 12,
    y2: 490.6,
    gradientTransform: "matrix(.87379 0 0 .87379 -30.976 -44.005)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4299",
    x1: 130.5,
    x2: 130.5,
    y1: 12,
    y2: 490.6,
    gradientTransform: "matrix(.87379 0 0 .87379 -62.529 -27.597)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4303",
    x1: 255.5,
    x2: 255.5,
    y1: 12,
    y2: 490.6,
    gradientTransform: "matrix(.87379 0 0 .87379 -46.752 -27.597)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4307",
    x1: 380.5,
    x2: 380.5,
    y1: 12,
    y2: 490.6,
    gradientTransform: "matrix(.87379 0 0 .87379 -30.976 -27.597)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4334",
    x1: 380.5,
    x2: 380.5,
    y1: 12,
    y2: 490.6,
    gradientTransform: "translate(-79,-76)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4336",
    x1: 255.5,
    x2: 255.5,
    y1: 12,
    y2: 490.6,
    gradientTransform: "translate(-79,-76)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4338",
    x1: 130.5,
    x2: 130.5,
    y1: 12,
    y2: 490.6,
    gradientTransform: "translate(-79,-76)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 130.5,
    x2: 130.5,
    y1: 12,
    y2: 490.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00efd1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00acea",
    offset: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cells"
  }, /*#__PURE__*/React.createElement("g", {
    fontFamily: "'Roboto Mono'",
    fontSize: "60px"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cell-text",
    x: 283.2334,
    y: 328.82812,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 283.2334,
    y: 328.82812
  }, "S"))), /*#__PURE__*/React.createElement("text", {
    className: "cell-text",
    x: 158.2334,
    y: 328.82812,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    xmlSpace: "preserve"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 158.2334,
    y: 328.82812
  }, "S"))), /*#__PURE__*/React.createElement("text", {
    className: "cell-text",
    x: 33.570312,
    y: 328.82812,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    xmlSpace: "preserve"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 33.570312,
    y: 328.82812
  }, "C"))), /*#__PURE__*/React.createElement("text", {
    className: "cell-text",
    x: 283.45312,
    y: 198.82812,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    xmlSpace: "preserve"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 283.45312,
    y: 198.82812
  }, "T"))), /*#__PURE__*/React.createElement("text", {
    className: "cell-text",
    x: 158.51172,
    y: 198.82812,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    xmlSpace: "preserve"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 158.51172,
    y: 198.82812
  }, "I"))), /*#__PURE__*/React.createElement("text", {
    className: "cell-text",
    x: 33.6875,
    y: 198.82745,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    xmlSpace: "preserve"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 33.6875,
    y: 198.82745
  }, "G"))), /*#__PURE__*/React.createElement("text", {
    className: "cell-text",
    x: 283.57031,
    y: 72.828125,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    xmlSpace: "preserve"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 283.57031,
    y: 72.828125
  }, "C"))), /*#__PURE__*/React.createElement("text", {
    className: "cell-text",
    x: 158.59961,
    y: 72.828125,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    xmlSpace: "preserve"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 158.59961,
    y: 72.828125
  }, "V"))), /*#__PURE__*/React.createElement("text", {
    className: "cell-text",
    x: 33.21875,
    y: 72.828125,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    xmlSpace: "preserve"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 33.21875,
    y: 72.828125
  }, "M")))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "blocksTwo",
    strokeWidth: 0.87379
  }, /*#__PURE__*/React.createElement("path", {
    d: "m265.24 262.5c-4.8258 0-8.7379 3.9121-8.7379 8.7379v72.524c0 4.8258 3.9121 8.7379 8.7379 8.7379h72.524c4.8258 0 8.7379-3.9121 8.7379-8.7379v-72.524c0-4.8258-3.9121-8.7379-8.7379-8.7379z",
    fill: "url(#linearGradient4307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.24 262.5c-4.8258 0-8.7379 3.9121-8.7379 8.7379v72.524c0 4.8258 3.9121 8.7379 8.7379 8.7379h72.524c4.8258 0 8.7379-3.9121 8.7379-8.7379v-72.524c0-4.8258-3.9121-8.7379-8.7379-8.7379z",
    fill: "url(#linearGradient4303)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.238 262.5c-4.8258 0-8.7379 3.9121-8.7379 8.7379v72.524c0 4.8258 3.9121 8.7379 8.7379 8.7379h72.524c4.8258 0 8.7379-3.9121 8.7379-8.7379v-72.524c0-4.8258-3.9121-8.7379-8.7379-8.7379z",
    fill: "url(#linearGradient4299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.24 132.5c-4.8258 0-8.7379 3.9121-8.7379 8.7379v72.524c0 4.8258 3.9121 8.7379 8.7379 8.7379h72.524c4.8258 0 8.7379-3.9121 8.7379-8.7379v-72.524c0-4.8258-3.9121-8.7379-8.7379-8.7379z",
    fill: "url(#linearGradient4295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.24 132.5c-4.8258 0-8.7379 3.9121-8.7379 8.7379v72.524c0 4.8258 3.9121 8.7379 8.7379 8.7379h72.524c4.8258 0 8.7379-3.9121 8.7379-8.7379v-72.524c0-4.8258-3.9121-8.7379-8.7379-8.7379z",
    fill: "url(#linearGradient4291)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.238 132.5c-4.8258 0-8.7379 3.9121-8.7379 8.7379v72.524c0 4.8258 3.9121 8.7379 8.7379 8.7379h72.524c4.8258 0 8.7379-3.9121 8.7379-8.7379v-72.524c0-4.8258-3.9121-8.7379-8.7379-8.7379z",
    fill: "url(#linearGradient4287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.24 6.5c-4.8258 0-8.7379 3.9121-8.7379 8.7379v72.524c0 4.8258 3.9121 8.7379 8.7379 8.7379h72.524c4.8258 0 8.7379-3.9121 8.7379-8.7379v-72.524c0-4.8258-3.9121-8.7379-8.7379-8.7379z",
    fill: "url(#linearGradient4283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.24 6.5c-4.8258 0-8.7379 3.9121-8.7379 8.7379v72.524c0 4.8258 3.9121 8.7379 8.7379 8.7379h72.524c4.8258 0 8.7379-3.9121 8.7379-8.7379v-72.524c0-4.8258-3.9121-8.7379-8.7379-8.7379z",
    fill: "url(#linearGradient4279)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.238 6.5c-4.8258 0-8.7379 3.9121-8.7379 8.7379v72.524c0 4.8258 3.9121 8.7379 8.7379 8.7379h72.524c4.8258 0 8.7379-3.9121 8.7379-8.7379v-72.524c0-4.8258-3.9121-8.7379-8.7379-8.7379z",
    fill: "url(#linearGradient4275)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "blocks",
    strokeWidth: 0.87379
  }, /*#__PURE__*/React.createElement("path", {
    d: "m265.24 262.5c-4.8258 0-8.7379 3.9121-8.7379 8.7379v72.524c0 4.8258 3.9121 8.7379 8.7379 8.7379h72.524c4.8258 0 8.7379-3.9121 8.7379-8.7379v-72.524c0-4.8258-3.9121-8.7379-8.7379-8.7379z",
    fill: "url(#linearGradient4307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.24 262.5c-4.8258 0-8.7379 3.9121-8.7379 8.7379v72.524c0 4.8258 3.9121 8.7379 8.7379 8.7379h72.524c4.8258 0 8.7379-3.9121 8.7379-8.7379v-72.524c0-4.8258-3.9121-8.7379-8.7379-8.7379z",
    fill: "url(#linearGradient4303)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.238 262.5c-4.8258 0-8.7379 3.9121-8.7379 8.7379v72.524c0 4.8258 3.9121 8.7379 8.7379 8.7379h72.524c4.8258 0 8.7379-3.9121 8.7379-8.7379v-72.524c0-4.8258-3.9121-8.7379-8.7379-8.7379z",
    fill: "url(#linearGradient4299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.24 132.5c-4.8258 0-8.7379 3.9121-8.7379 8.7379v72.524c0 4.8258 3.9121 8.7379 8.7379 8.7379h72.524c4.8258 0 8.7379-3.9121 8.7379-8.7379v-72.524c0-4.8258-3.9121-8.7379-8.7379-8.7379z",
    fill: "url(#linearGradient4295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.24 132.5c-4.8258 0-8.7379 3.9121-8.7379 8.7379v72.524c0 4.8258 3.9121 8.7379 8.7379 8.7379h72.524c4.8258 0 8.7379-3.9121 8.7379-8.7379v-72.524c0-4.8258-3.9121-8.7379-8.7379-8.7379z",
    fill: "url(#linearGradient4291)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.238 132.5c-4.8258 0-8.7379 3.9121-8.7379 8.7379v72.524c0 4.8258 3.9121 8.7379 8.7379 8.7379h72.524c4.8258 0 8.7379-3.9121 8.7379-8.7379v-72.524c0-4.8258-3.9121-8.7379-8.7379-8.7379z",
    fill: "url(#linearGradient4287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.24 6.5c-4.8258 0-8.7379 3.9121-8.7379 8.7379v72.524c0 4.8258 3.9121 8.7379 8.7379 8.7379h72.524c4.8258 0 8.7379-3.9121 8.7379-8.7379v-72.524c0-4.8258-3.9121-8.7379-8.7379-8.7379z",
    fill: "url(#linearGradient4283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.24 6.5c-4.8258 0-8.7379 3.9121-8.7379 8.7379v72.524c0 4.8258 3.9121 8.7379 8.7379 8.7379h72.524c4.8258 0 8.7379-3.9121 8.7379-8.7379v-72.524c0-4.8258-3.9121-8.7379-8.7379-8.7379z",
    fill: "url(#linearGradient4279)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.238 6.5c-4.8258 0-8.7379 3.9121-8.7379 8.7379v72.524c0 4.8258 3.9121 8.7379 8.7379 8.7379h72.524c4.8258 0 8.7379-3.9121 8.7379-8.7379v-72.524c0-4.8258-3.9121-8.7379-8.7379-8.7379z",
    fill: "url(#linearGradient4275)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cell-background",
    d: "m266.5 272.5h70v70h-70z",
    fill: "#ffa726",
    strokeWidth: 1.0938
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cell",
    d: "m343 256h-83a10 10 0 0 0-10 10v83a10 10 0 0 0 10 10h83a10 10 0 0 0 10-10v-83a10 10 0 0 0-10-10zm-9 84h-64v-64h64z",
    fill: "url(#linearGradient4334)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cell-background",
    d: "m141.5 272.5h70v70h-70z",
    fill: "#ffa726",
    strokeWidth: 1.0938
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cell",
    d: "m218 256h-83a10 10 0 0 0-10 10v83a10 10 0 0 0 10 10h83a10 10 0 0 0 10-10v-83a10 10 0 0 0-10-10zm-9 84h-64v-64h64z",
    fill: "url(#linearGradient4336)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cell-background",
    d: "m16.5 272.5h70v70h-70z",
    fill: "#ffa726",
    strokeWidth: 1.0938
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cell",
    d: "m93 256h-83a10 10 0 0 0-10 10v83a10 10 0 0 0 10 10h83a10 10 0 0 0 10-10v-83a10 10 0 0 0-10-10zm-9 84h-64v-64h64z",
    fill: "url(#linearGradient4338)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cell-background",
    d: "m266.5 142.5h70v70h-70z",
    fill: "#ffa726",
    strokeWidth: 1.0938
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cell",
    d: "m343 126h-83a10 10 0 0 0-10 10v83a10 10 0 0 0 10 10h83a10 10 0 0 0 10-10v-83a10 10 0 0 0-10-10zm-9 83h-64v-63h64z",
    fill: "url(#linearGradient4334)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cell-background",
    d: "m141.5 142.5h70v70h-70z",
    fill: "#ffa726",
    strokeWidth: 1.0938
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cell",
    d: "m218 126h-83a10 10 0 0 0-10 10v83a10 10 0 0 0 10 10h83a10 10 0 0 0 10-10v-83a10 10 0 0 0-10-10zm-9 83h-64v-63h64z",
    fill: "url(#linearGradient4336)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cell-background",
    d: "m16.5 142.5h70v70h-70z",
    fill: "#ffa726",
    strokeWidth: 1.0938
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cell",
    d: "m93 126h-83a10 10 0 0 0-10 10v83a10 10 0 0 0 10 10h83a10 10 0 0 0 10-10v-83a10 10 0 0 0-10-10zm-9 83h-64v-63h64z",
    fill: "url(#linearGradient4338)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cell-background",
    d: "m266.5 16.5h70v70h-70z",
    fill: "#ffa726",
    strokeWidth: 1.0938
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cell",
    d: "m343 0h-83a10 10 0 0 0-10 10v83a10 10 0 0 0 10 10h83a10 10 0 0 0 10-10v-83a10 10 0 0 0-10-10zm-9 84h-64v-64h64z",
    fill: "url(#linearGradient4334)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cell-background",
    d: "m141.5 16.5h70v70h-70z",
    fill: "#ffa726",
    strokeWidth: 1.0938
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cell",
    d: "m218 0h-83a10 10 0 0 0-10 10v83a10 10 0 0 0 10 10h83a10 10 0 0 0 10-10v-83a10 10 0 0 0-10-10zm-9 84h-64v-64h64z",
    fill: "url(#linearGradient4336)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cell-background",
    d: "m16.5 16.5h70v70h-70z",
    fill: "#ffa726",
    strokeWidth: 1.0938
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cell",
    d: "m93 0h-83a10 10 0 0 0-10 10v83a10 10 0 0 0 10 10h83a10 10 0 0 0 10-10v-83a10 10 0 0 0-10-10zm-9 84h-64v-64h64z",
    fill: "url(#linearGradient4338)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAcronymGridOptimized, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/acronym-grid-optimized.aaaa6f02.svg";
export { ForwardRef as ReactComponent };